import { showApiErrors } from '@/utils';
import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { getProfile, updateProfile } from './actionCreators';
import { initialState, PROFILE_SLICE_NAME, ProfileState } from './models';

export const slice = createSlice({
  name: PROFILE_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(isFulfilled(getProfile, updateProfile), (state: ProfileState, action) => {
        const { payload } = action;
        state.isLoading = false;
        state.error = null;
        state.profile = payload;
      })
      .addMatcher(isPending(getProfile, updateProfile), (state: ProfileState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getProfile, updateProfile), (state: ProfileState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;

        showApiErrors(error);
      });
  },
});

export default slice.reducer;
